import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function BackToMore() {
  return (
    <Link
      to="/more"
      data-testid="back-to-more"
      className="inline-flex items-center"
      style={{
        gap: "4px",
        color: "var(--primary-dark)",
        fontWeight: 800,
        fontSize: "16px",
        marginBottom: "12px",
      }}
    >
      <ChevronLeft size={20} color="var(--primary-dark)" strokeWidth={2.5} />
      <span>More</span>
    </Link>
  );
}
